/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AppointmentStatus/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'



/** @type {import('Simple/types.js').View} */
export default function AppointmentStatus({
  children,
  viewPath = "/DesignSystem/TimeGrid/FullCalendarTimegrid/Appointment/AppointmentStatus"
  
}) {
let eventStateValueData = fromData.useDataFormat({ viewPath,
context: 'event',
path: 'state',
format: fromFormat.getStateText,
})
  return (<React.Fragment
>
<TysiaTag
  viewPath={`${viewPath}/TysiaTag`}
 type="grey"
 style="outline"
 maxWidth={80}
>
{childProps => (
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 data="event.state"
 format="/Data/format.js getStateText"
 text={eventStateValueData}
/>
)}
</TysiaTag>
{children}
</React.Fragment>)
}